// import configApi from '@/api/sys/config'

const sys = {
	state: {
		title: '小丑鱼掌柜',
		version: '',
		login: '',
		company: '',
		initConfig: false,
		pageSize: 50,//列表的默认页容量
		permissionRouters: [],//权限路由表
		permissionMenus: [], //权限菜单列表
		isSyncOrder: false,
		orderSyncCount: 0,
		orderSyncLoading: false,
	},
	getters: {

	},
	mutations: {
		SET_INITCONFIG(state, initConfig) {
			state.initConfig = initConfig
		},
		SET_VERSION(state, version) {
			state.version = version
		},
		SET_LOGIN(state, login) {
			state.login = login
		},
		SET_TITLE(state, title) {
			state.title = title
		},
		SET_COMPANY(state, company) {
			state.company = company
		},
		SET_PERMISSION_ROUTERS(state, routers) {
			state.permissionRouters = routers;
		},
		SET_PERMISSION_MENUS(state, menus) {
			state.permissionMenus = menus;
		},
		SET_IS_SYNC_ORDER(state, isSyncOrder) {
			state.isSyncOrder = isSyncOrder;
		},
		SET_ORDER_SYNC_COUNT(state, orderSyncCount) {
			state.orderSyncCount = orderSyncCount;
		},
		SET_ORDER_SYNC_LOADING(state, orderSyncLoading) {
			state.orderSyncLoading = orderSyncLoading;
		}
	},
	actions: {
		initSysConfig({ state, commit }, path) {
			return new Promise((resolve, reject) => {
				resolve()
			})
		},
		setIsSyncOrder({ commit }, value) {
			commit('SET_IS_SYNC_ORDER', value)
		},
		setOrderSyncCount({ commit }, value) {
			commit('SET_ORDER_SYNC_COUNT', value)
		},
		setOrderSyncLoading({ commit }, value) {
			commit('SET_ORDER_SYNC_LOADING', value)
		}
	}
}
export default sys
